/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TouchpointDTOBatchJobExecutionStatus =
  (typeof TouchpointDTOBatchJobExecutionStatus)[keyof typeof TouchpointDTOBatchJobExecutionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TouchpointDTOBatchJobExecutionStatus = {
  FAILED: "FAILED",
  RUNNING: "RUNNING",
  SUCCESSFUL: "SUCCESSFUL",
} as const;
